<script>
	import NUNISYNTH from './NUNISYNTH.svelte'
    import LambdaCalcEval from './LambdaCalcEval.svelte'
    import WiFiCar from './WiFiCar.svelte'
    import CodingPro from './CodingPro.svelte'
    import Bloodblaze from './BLOODBLAZE.svelte';
</script>

<h3> Selected Projects </h3>
<NUNISYNTH/>
<Bloodblaze/>
<LambdaCalcEval/>
<CodingPro/>
<WiFiCar/>